import supabase from './supabase';

export async function recordCountry(session, visitor) {
  // CRA has no Netlify function runtime. Do not assign a fake local country.
  if (['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)) return;
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    let country;
    try {
      const response = await fetch('/.netlify/functions/visitor-country', { signal: controller.signal, cache: 'no-store' });
      if (!response.ok) return;
      ({ country } = await response.json());
    } finally { clearTimeout(timeout); }
    if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) return;
    await supabase.rpc('record_visit_country', { session_key: session, visitor_key: visitor, country });
  } catch { /* Country lookup must never block visit tracking or app usage. */ }
}
